<template>
  <div :class="['editors-staff-authors-skeleton', { _mobile: isMobile }]">
    <div class="editors-staff-authors-skeleton__section-title"></div>
    <ul class="editors-staff-authors-skeleton__list">
      <li v-for="index in 6" :key="index" class="editors-staff-authors-skeleton__item">
        <div class="editors-staff-authors-skeleton__card">
          <div class="editors-staff-authors-skeleton__card-top">
            <div class="editors-staff-authors-skeleton__avatar"></div>
            <div class="editors-staff-authors-skeleton__info"></div>
          </div>
          <div class="editors-staff-authors-skeleton__categories"></div>
        </div>
      </li>
    </ul>
    <div class="editors-staff-authors-skeleton__more"></div>
  </div>
</template>

<script setup lang="ts">
const isMobile: boolean = useIsMobile();
</script>

<style lang="less">
.editors-staff-authors-skeleton {
  .flex-column(@size-x10);

  &__section-title {
    .skeleton(200px, 39px);
  }

  &__list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: @size-x6;
  }

  &__item {
    display: flex;
  }

  &__card {
    .flex-column(@size-x5);
    .box-shadow();

    width: 100%;
    padding: @size-x5;
    border-radius: @main-size;
  }

  &__card-top {
    display: flex;
    gap: @size-x6;
  }

  &__avatar {
    .skeleton(100px, 100px);

    flex-shrink: 0;
  }

  &__info {
    .skeleton(100%, 100px);
  }

  &__categories {
    .skeleton(100%, 60px);
  }

  &__more {
    .skeleton(140px, 21px);

    align-self: flex-start;
  }

  &._mobile &__section-title {
    width: 160px;
    height: 30px;
  }

  &._mobile &__list {
    grid-template-columns: 1fr;
  }

  &._mobile &__avatar {
    width: 80px;
    height: 80px;
  }
}
</style>
